<template>
    <b-modal scrollable b-modal ref="mdlScaleValutazione" id="mdlScaleValutazione" size="xl" style="height: 100%" :title="titoloModale" @ok="onInvia" @hidden="onHidden" no-close-on-backdrop no-close-on-esc>
        <div class="sa-tab-scroll">
            <b-card v-if="modalStep === 0" class="sa-card sa-card-border" header=" " header-tag="header" footer-tag="footer" title="">
                <b-table sticky-header ref="table" stacked="sm" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(actions)="{ item }">
                 
                        <!-- <b-icon v-if="item.compilata" icon="check-square-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-square-fill" variant="danger"></b-icon> -->
                        <b-container class="bv-example-row">
                            <!--   <b-button v-if="item.compilata" size="sm" variant="outline-success" disabled>
                                <fofnt-awesome-icon icon="check"></fofnt-awesome-icon>
                            </b-button> -->
                            <!--  <b-button v-else size="sm" variant="outline-danger" disabled>
                                <font-awesome-icon icon="check"></font-awesome-icon>
                            </b-button> -->
                            <b-button v-if="item.path !== null && item.path !== ''" size="sm" title="Modifica Richiesta" variant="outline-success" @click="onInserisciModifica(item)">
                                <font-awesome-icon icon="edit"></font-awesome-icon>
                            </b-button>
                            <!-- <b-button size="sm" v-b-tooltip.hover title="Visualizza Richiesta" variant="outline-secondary" @click="onClickVisualizzaScala(item)" class="mr-1 no-text">
                                <font-awesome-icon icon="eye" />
                            </b-button> -->
                            <!-- <b-button size="sm" variant="btn btn-outline-info waves-effect waves-light width-sm no-text" @click="onVisualizzaPdf(item)" :disabled="!item.compilata">
                <i class="bi bi-filetype-pdf"></i></b-button>  
                         <print-component v-if="item.compilata" :data="getPrintData(item.path)" :linkPrintData="linkPrintData(item)" typeButton="small"></print-component> -->
                        </b-container>
                    </template>
                </b-table>
            </b-card>
            <b-card v-show="modalStep === 1" v-for="(listaGruppo, index) in gruppoItems" :key="index" class="sa-card sa-card-border" :header="listaGruppo.gruppo" header-tag="header" footer-tag="footer" title="">
                <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaGruppo.fattori" :fields="fieldsScaleValutazione" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header">
                    <template #cell(fattore)="item">
                        {{ item.item.fattore }}
                    </template>
                    <template #cell(check)="{ item }">
                        <b-form-select v-if="item.inputType === 'SELECT'" id="inline-form-custom-select-pref" class="mb-2 mr-sm-2 mb-sm-0" v-model="item.punteggio" :value="null" value-field="value" text-field="text" :options="item.punteggioOptions" :disabled="isModalView" @change="onChangePunteggio(item)">
                            <template #first>
                                <b-form-select-option :value="null" disabled> -Seleziona un'opzione- </b-form-select-option>
                            </template>
                        </b-form-select>

                        <b-form-checkbox v-else v-model="item.check" :label="item" :checked="item.check" :disabled="isModalView" switch></b-form-checkbox>
                    </template>
                </b-table>
            </b-card>
            <b-card v-show="modalStep === 1" class="sa-card sa-card-border" header="Totale" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <span class="sa-label-data">{{ punteggioTotale }}</span>
                    </b-col>
                </b-row>
            </b-card>
        </div>

        <template #modal-footer>
            <b-button v-if="!isModalView" size="md" class="no-text" variant="outline-danger" @click="onClickUndo">Annulla</b-button>
            <b-button v-if="!isModalView" @click="onSalvaRichiesta" :disabled="modalStep !== 1" variant="outline-success">Salva</b-button>
            <b-button v-if="isModalView" @click="onClickOk" variant="outline-primary">Ok</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";

export default {
    components: { ModalError },
    props: {
        // utente: {
        //     type: Object,
        //     default: function () {
        //         return null;
        //     },
        // },
    },
    data() {
        return {
            idAccettazione: null,
            modalStep: 0,
            sezione: "SCALEVALUTAZIONE",
            pathResourceSchedeValutazione: "/rsaschedevalutazione",
            pathResource: "/rsascalevalutazionepaziente",
            pathResourceScala: "/rsascalavalutazionepaziente",
            punteggioTotale: 0,
            listKey: 1,
            perPage: 50,
            currentPage: 1,
            titoloModale: "SCALE DI VALUTAZIONE",
            scalaValutazioneRisposte: [],
            isModalView: false,
            gruppoItems: [],
            rigaSelezionata: {},
            listaDettaglio: [],
            jsonDataScalaCompilata: {},
            scalaCompilata: {},
            inputType: "",
            jsonData: { idAccettazione: "", tipoScale: "", punteggio: "" },
            filtro: {},
            items: [],
            fields: [
                {
                    label: "Tipo Scheda",
                    key: "tipoScheda",
                },
                {
                    label: "",
                    key: "actions",
                    class: "sa-table-column-action-double",
                },
            ],
            fieldsScaleValutazione: [
                {
                    label: "Descrizione",
                    key: "fattore",
                    sortable: true,
                },
                // {
                //     label: "Punteggio",
                //     key: "punteggio",
                //     thStyle: "width: 10rem",
                //     tdClass: "text-center sa-column-widh",
                // },
                {
                    label: "",
                    key: "check",
                    sortable: true,
                    thStyle: "width: 10rem",
                    tdClass: "text-center sa-column-widh",
                },
                // {
                //   label: "",
                //   key: "action",
                //   thStyle: "width: 10rem",
                // },
            ],
        };
    },

    watch: {
        gruppoItems: {
            handler() {
                let me = this;
                me.listaDettaglio = [];
                me.punteggioTotale = 0;
                if (me.gruppoItems.length > 0) {
                    me.gruppoItems.forEach((element) => {
                        element.fattori.forEach((element) => {
                            element.valore = element.check ? 1 : 0;
                            me.punteggioTotale += me.inputType === "SELECT" ? Number(element.punteggio) : element.valore * element.punteggio;
                            me.listaDettaglio.push({ fattore: element.fattore, gruppo: element.gruppo, punteggio: element.punteggio, ordinamento: element.ordinamento, valore: element.valore });
                        });
                    });
                }
            },
            deep: true,
            immediate: false,
        },
        modalStep: {
            handler() {
                let me = this;
                switch (me.modalStep) {
                    case 0:
                        me.titoloModale = "Selezione Scala";
                        break;
                    case 1:
                        me.titoloModale = me.isModalView ? "Visualizzazione: " + me.rigaSelezionata.tipoScheda : "Compilazione: " + me.rigaSelezionata.tipoScheda;
                        break;
                }
            },
            immediate: true,
        },
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        show(id) {
            let me = this;
            me.idAccettazione = id;
            me.gruppoItems = {};
            me.rigaSelezionata = {};
            me.$refs.mdlScaleValutazione.show();
            me.loadData();
        },
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceSchedeValutazione;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            me.filtro.sezione = me.sezione;
            axios
                .get(link, { params: me.filtro })
                .then((response) => {
                    me.items = [];

                    if (!me.isScalaValutazioneRiferimentiDiagnostici) {
                        me.items = response.data.data.list;
                    } else {
                        response.data.data.list.forEach((element) => {
                            switch (element.tipoScheda) {
                                case "SCALA BRADEN":
                                    me.items.push(element);
                                    break;
                                case "SCALA TINETTI":
                                    me.items.push(element);
                                    break;
                                case "SCALA MINIMENTAL SHORT":
                                    me.items.push(element);
                                    break;
                                case "SCALA BARTHEL":
                                    me.items.push(element);
                                    break;
                            }
                        });
                    }
                    me.rows = response.data.data.recordsNumber;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onInserisciModifica(value) {
            let me = this;
            me.modalStep = 1;
            me.rigaSelezionata = value;
            me.loadScalaValutazione();
        },
        loadScalaValutazione() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.rigaSelezionata.path, {}, me.resultResponseScalaValutazione, me.resultErrorScalaValutazione);
        },
        resultResponseScalaValutazione(response) {
            let me = this;
            me.scalaValutazioneRisposte = response.data.data.list;
            me.buildSchedaScala(me.scalaValutazioneRisposte);
        },
        resultErrorScalaValutazione(error) {
            console.log(error);
        },
        buildSchedaScala(array) {
            let me = this;
            me.gruppoItems = {};
            me.inputType = array[0].inputType === "SELECT" ? array[0].inputType : "";
            array.forEach((element) => {
                if (!me.gruppoItems[element.gruppo]) {
                    me.gruppoItems[element.gruppo] = {
                        gruppo: element.gruppo,
                        fattori: [],
                    };
                }
                if (element.inputType === "SELECT") {
                    let punteggioOptions = element.punteggio.split(";");
                    me.gruppoItems[element.gruppo].fattori.push({ gruppo: element.gruppo, fattore: element.fattore, punteggio: null, ordinamento: element.ordinamento, inputType: element.inputType, punteggioOptions: punteggioOptions });
                } else {
                    me.gruppoItems[element.gruppo].fattori.push({ gruppo: element.gruppo, fattore: element.fattore, punteggio: element.punteggio, ordinamento: element.ordinamento });
                }
            });
            me.gruppoItems = Object.values(me.gruppoItems);
        },
        onInvia() {
            let me = this;
            me.modalStep = 0;
        },
        onSalvaRichiesta() {
            let me = this;
            me.modalStep = 0;
            me.jsonData = { idAccettazione: me.idAccettazione, punteggio: me.punteggioTotale, dataOraCompilazione: new Date().getTime(), listaDettaglio: me.listaDettaglio, tipoScale: me.rigaSelezionata.tipoScheda };
            me.jsonData.listaDettaglio = me.listaDettaglio;
            me.jsonData.punteggio = me.punteggioTotale;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.resultSaveResponse, me.resultSaveError);
        },
        resultSaveResponse() {
            let me = this;
            me.$emit("afterSave");
            me.$refs.mdlScaleValutazione.hide();
        },
        resultSaveError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onHidden() {
            let me = this;
            me.isModalView = false;
            me.modalStep = 0;
        },
        onClickUndo() {
            let me = this;
            if (me.modalStep === 1) {
                me.modalStep = 0;
            } else {
                me.$refs.mdlScaleValutazione.hide();
                me.modalStep = 0;
            }
        },
        visualizzaScala(item) {
            let me = this;
            me.isModalView = true;
            me.items.forEach((element) => {
                if (element.tipoScheda === item.tipoScale) {
                    me.rigaSelezionata = element;
                }
            });
            me.loadScalaValutazione();
            me.loadScalaCompilata(item.id);
        },
        loadScalaCompilata(id) {
            let me = this;
            let link = me.pathResource + "/" + id;
            UtilityMixin.methods.loadDataResources(link, {}, me.resulResponseVisualizzaScala, me.resulErrorVisualizzaScala);
        },
        resulResponseVisualizzaScala(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.buildSchedaScalaCompilata(me.jsonData.listaDettaglio);
            me.modalStep = 1;
            me.$refs.mdlScaleValutazione.show();
        },
        resulErrorVisualizzaScala(error) {
            console.log(error);
        },
        buildSchedaScalaCompilata(array) {
            let me = this;
            me.scalaCompilata = {};
            array.forEach((element) => {
                if (!me.scalaCompilata[element.gruppo]) {
                    me.scalaCompilata[element.gruppo] = {
                        gruppo: element.gruppo,
                        fattori: [],
                    };
                }
                if (me.inputType === "SELECT") {
                    let punteggioOptions = [element.punteggio];
                    me.scalaCompilata[element.gruppo].fattori.push({ id: element.id, idRsaScaleValutazionePaziente: element.idRsaScaleValutazionePaziente, gruppo: element.gruppo, fattore: element.fattore, punteggio: element.punteggio, ordinamento: element.ordinamento, valore: element.valore, punteggioOptions: punteggioOptions, inputType: me.inputType });
                } else {
                    me.scalaCompilata[element.gruppo].fattori.push({ id: element.id, idRsaScaleValutazionePaziente: element.idRsaScaleValutazionePaziente, gruppo: element.gruppo, fattore: element.fattore, punteggio: element.punteggio, ordinamento: element.ordinamento, valore: element.valore, check: element.valore === 1 });
                }
            });
            me.scalaCompilata = Object.values(me.scalaCompilata);
            me.gruppoItems = me.scalaCompilata;
        },
        onClickOk() {
            let me = this;
            me.isModalView = false;
            me.$refs.mdlScaleValutazione.hide();
        },
        onChangePunteggio(value) {
            value.check = true;
        },
    },
};
</script>

<style></style>
